/*
 * Adzuki.Editor
 * TinyMCE WYSIWYG text editor shim
 * https://www.tinymce.com/docs/
 */

(function Editors($, Adzuki, tinymce)
{
	"use strict";

	var $modal     = $('.modal'),
	    image_size = 'original',
	    script_url_whitelist = [
	        'form.jotform.com',
	        'assets.freshdesk.com',
	        'reviews.sproutloud.com',
	        'platform.reviewmgr.com',
	        'static.reviewmgr.com',
	        'www.tiktok.com',
			'widgets.meetsoci.com',
	    ];

	var editor = function Editor(el, options)
	{
		var self = this,
		    menubar_sets = {
		        // when adding menubars, please keep them in alphabetical order
		        // to make them easier to manage
		        account     : 'edit format table',
		        advanced    : 'edit insert view format table tools',
		        email       : 'edit view format',
		        guide       : 'edit view format',
		        minimal     : false,
		        moderate    : 'edit view format',
		        partner_hub : false,
		        simple      : 'edit view format',
		        simple_email: 'edit view format',
		        text_formats: false,
		        web         : 'edit insert view format table tools',
		    },
		    plugin_sets = {
		        // when adding plugins, please keep them in alphabetical order
		        // to make them easier to manage
		        account     : 'code lists table',
		        advanced    : 'code image link lists paste preview table media',
		        email       : 'code image link lists preview table',
		        guide       : 'code image link lists preview table',
		        minimal     : 'lists paste',
		        moderate    : 'code image link lists paste preview table media',
		        partner_hub : 'lists paste',
		        simple      : 'code image link lists paste preview table',
		        simple_email: 'code image link lists paste preview table',
		        text_formats: 'link lists',
		        web         : 'anchor code image imagetools link lists paste preview table media bootstrap3grid',
		    },
		    toolbar_sets = {
		        // custom buttons we add below in setup()
		        // 	cp_images, cp_forms, cp_form_remove, gpt_prompt

		        // when adding toolbars, please keep them in alphabetical order
		        // to make them easier to manage
		        account: [
		            'bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | code | table',
		        ],
		        advanced: [
		            'fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent blockquote | link unlink anchor image code | table charmap emoticons | cp_images cp_videos | cut copy paste pastetext snippets | searchreplace | undo redo | hr visualchars | fullscreen',
		        ],
		        email: [
		            'fontselect fontsizeselect | bold italic underline | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | table | cp_images | snippets',
		        ],
		        guide: [
		            'fontselect fontsizeselect | bold italic underline | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | table | cp_images | snippets',
		        ],
		        minimal: [
		            'bold italic underline | bullist numlist outdent indent',
		        ],
		        moderate: [
		            'fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image code | table | cp_images cp_videos | snippets',
		        ],
		        partner_hub: [
		            'bold italic underline | bullist numlist outdent indent',
		        ],
		        simple: [
		            'fontsizeselect | bold italic underline | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image code | table | cp_images cp_videos | pastetext snippets',
		        ],
		        simple_email: [
		            'fontsizeselect | bold italic underline | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image code | table | cp_images | pastetext snippets',
		        ],
		        text_formats: [
		            'fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink',
		        ],
		        web: [
		            'fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent blockquote | link unlink anchor image media code | bootstrap3grid table charmap emoticons | cp_images cp_forms cp_form_remove cp_videos | cut copy paste pastetext snippets | searchreplace | undo redo | hr visualchars | fullscreen',
		        ],
		    },
		    statusbar_sets = {
		        // when adding status bar, please keep them in alphabetical order
		        // to make them easier to manage
				account     : true,
				advanced    : true,
				email       : true,
				guide       : true,
				minimal     : false,
				moderate    : true,
				partner_hub : false,
				simple      : true,
				simple_email: true,
				text_formats: true,
				web         : true,
		    },

		    defaults = {
		        // skin              : 'oxide-dark',
		        menubar           : menubar_sets.simple,
		        plugins           : plugin_sets.simple,
		        toolbar           : toolbar_sets.simple,
		        statusbar         : statusbar_sets.simple,
		        contextmenu       : false,
		        removed_menuitems : 'newdocument',
		        image_advtab      : true,
		        browser_spellcheck: true,
		        relative_urls     : false,
		        remove_script_host: false,
		        setup             : function _setup(editor)
		        {
		            editor.on('change', function _change() {
		                _updateHiddenInput(editor);
		            });

		            editor.ui.registry.addButton('cp_images', {
		                // this is the actual, real way to have custom images
		                // in a custom button in their new ui framework, without
		                // having to make an svg and using their new icon registry api
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-image-picker.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Cruise Planners Images',
		                onAction: function clickCustomButton(event) {
		                    showImagePicker(editor);
		                }
		            });

		            editor.ui.registry.addButton('cp_forms', {
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-forms.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Add form',
		                onAction: function clickCustomButton(event) {
		                    showFormSelector(editor);
		                }
		            });

		            editor.ui.registry.addButton('cp_form_remove', {
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-forms-remove.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Remove form',
		                onAction: function clickCustomButton(event) {
		                    removeForm(editor);
		                }
		            });

					editor.ui.registry.addButton('cp_form_remove', {
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-forms-remove.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Remove form',
		                onAction: function clickCustomButton(event) {
		                    removeForm(editor);
		                }
		            });

		            editor.ui.registry.addButton('gpt_prompt', {
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-maxx-gpt.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Maxx Intelligence Content Generator',
		                onAction: function clickCustomButton(event) {
		                    showGptPrompt(editor);
		                }
		            });

					editor.ui.registry.addButton('snippets', {
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-snippets.png " style="height: 24px;width: 20px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Snippets',
		                onAction: function clickCustomButton(event) {
		                    showSnippets(editor);
		                }
		            });

					editor.ui.registry.addButton('cp_videos', {
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-videos.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Video Library',
		                onAction: function clickCustomButton(event) {
		                    showVideoLibrary(editor);
		                }
		            });

		            // save internal reference to the tinymce editor itself
		            self._editor = editor;
		        },
		    },
		    _updateHiddenInput = Adzuki.Debounce(function __updateHiddenInput(editor) {
		        // this syncs the hidden input's value with tinymce's contents
		        editor.save();

		        // this syncs EVERY tinymce editor on the page
		        // tinymce.triggerSave();
		    }, 250),
		    opts = $.extend({}, defaults, options),
		    editorElement;

		try
		{
			if ($.isEmptyObject(tinymce)) {
				throw new Error('TinyMCE is not loaded.');
			}

			if ((this instanceof Editor) === false) {
				return new Editor(el, options);
			}

			if (typeof el === 'string') {
				editorElement = el;
				this.$editor  = $(editorElement);
			}
			else if (typeof el === 'object' && (el instanceof jQuery)) {
				throw new Error("jQuery objects are not supported.");
			}

			if (!this.$editor.length) {
				throw new Error('cannot find ' + editorElement);
			}

			opts.selector = editorElement;

			// editor type set via form data attribute
			if (this.$editor.data('editor-type') !== undefined) {
				opts.menubar   = menubar_sets[this.$editor.data('editor-type')];
				opts.plugins   = plugin_sets[this.$editor.data('editor-type')];
				opts.toolbar   = toolbar_sets[this.$editor.data('editor-type')];
				opts.statusbar = statusbar_sets[this.$editor.data('editor-type')];
			}

			// editor type being set via JS call to Adzuki.Editor
			if (opts.editor_type !== undefined) {
				opts.menubar   = menubar_sets[opts.editor_type];
				opts.plugins   = plugin_sets[opts.editor_type];
				opts.toolbar   = toolbar_sets[opts.editor_type];
				opts.statusbar = statusbar_sets[opts.editor_type];
			}

			if (Adzuki.gpt_enabled === 1) {
				opts.toolbar[0] += ' | gpt_prompt';
			}

			// imagetools needs a proxy to work
			// https://www.tiny.cloud/docs/plugins/opensource/imagetools/
			if (opts.plugins.indexOf('imagetools') > -1) {
				opts.imagetools_proxy   = Adzuki.base_uri + '/Images/mceproxy/';
				opts.imagetools_toolbar = 'rotateleft rotateright | flipv fliph | editimage imageoptions';
			}

			// special stylings for agent websites
			if (opts.content_css !== undefined) {
				opts.content_css = [
					'//fonts.googleapis.com/css?family=Open+Sans',
					Adzuki.base_uri+'/adzuki/css/vendor/vendor.min.css',
					Adzuki.base_uri+'/adzuki/css/'+opts.content_css,
				];

				opts.font_formats = 'Arial=arial,helvetica,sans-serif;'
				+'Arial Black=arial black,sans-serif;'
				+'Book Antiqua=book antiqua,palatino,serif;'
				+'Comic Sans MS=comic sans ms,sans-serif;'
				+'Open Sans=Open Sans, sans-serif;'
				+'Times New Roman=times new roman,times,serif;';

				opts.fontsize_formats = '8px 10px 12px 14px 18px 24px 36px';
			}

			// if we have to add insecure shit due to agents requesting it
			// at least we can /try/ to make it decent with a whitelist
			opts.extended_valid_elements = 'video[controls|playsinline|width|height|autoplay|muted],source[src|type],script[type=text/javascript|src]';
			opts.urlconverter_callback   = function validateUrl(url, node, on_save, name)
			{
				var script,
				    mce_settings = self._editor.settings;

				// parse the script url, check if hostname is in whitelist
				if (node === 'script')
				{
					script = document.createElement('a');
					script.href = url;

					if (script_url_whitelist.indexOf(script.hostname) >= 0) {
						return url;
					}

					return '';
				}

				// port of original tinymce.convertURL() functionality
				// without recursively calling the urlconverter_callback function
				if (
					!mce_settings.convert_urls ||
					node === "a" ||
					(node !== undefined && node.nodeName && node.nodeName.toLowerCase() === 'a') ||
					url.indexOf('file:') === 0 ||
					url.length === 0
				) {
					// console.log('url', url);
					return url;
				}
				else if (
					!mce_settings.convert_urls ||
					node === "img" ||
					(node !== undefined && node.nodeName && node.nodeName.toLowerCase() === 'img') ||
					url.indexOf('file:') === 0 ||
					url.length === 0
				) {
					// console.log('url', url);
					return url;
				}
				else if (mce_settings.relative_urls) {
					// console.log('documentBaseURI.toRelative', self._editor.documentBaseURI.toRelative(url));
					return self._editor.documentBaseURI.toRelative(url);
				}

				// console.log('documentBaseURI.toAbsolute', self._editor.documentBaseURI.toAbsolute(url, mce_settings.remove_script_host));
				return self._editor.documentBaseURI.toAbsolute(url, mce_settings.remove_script_host);
			};

			// set base path for icons, plugins, skins, and themes
			tinymce.baseURL = Adzuki.base_uri + '/adzuki/js/vendor/tinymce';

			// remove any tinymce instances that are already initialized for this el
			tinymce.remove(editorElement);

			// tinymce 5 doesn't allow us to extend the default colormap
			// list of available colors, so set all of the stock ones here
			// and add the cruise planners one as well.
			// the weird structure is legit, not a typo. idunno, man.
			opts.color_map = [
				'#BFEDD2', 'Light Green',
				'#FBEEB8', 'Light Yellow',
				'#F8CAC6', 'Light Red',
				'#ECCAFA', 'Light Purple',
				'#C2E0F4', 'Light Blue',
				'#2DC26B', 'Green',
				'#F1C40F', 'Yellow',
				'#E03E2D', 'Red',
				'#B96AD9', 'Purple',
				'#3598DB', 'Blue',
				'#169179', 'Dark Turquoise',
				'#E67E23', 'Orange',
				'#BA372A', 'Dark Red',
				'#843FA1', 'Dark Purple',
				'#236FA1', 'Dark Blue',
				'#ECF0F1', 'Light Gray',
				'#CED4D9', 'Medium Gray',
				'#95A5A6', 'Gray',
				'#7E8C8D', 'Dark Gray',
				'#34495E', 'Navy Blue',
				'#000000', 'Black',
				'#FFFFFF', 'White',
				"#3AAF49", "Cruise Planners Green",
			];

			// tinymce 5 changed how height works, this compensates for the change
			// this only works if a height is specified
			if (opts.height) {
				opts.height += 170;
			}
			else {
				// tinymce5's default height seems a bit smaller than before
				// so this'll make them look about the same
				opts.height = 300;
			}

			// remove "powered by"
			opts.branding = false;

			// support image uploading
			// function(blobInfo, successHandler, failureHandler)
			if (typeof opts.images_upload_handler !== 'function'
				&& this.$editor.data('image-upload-url') !== undefined)
			{
				opts.images_upload_url = Adzuki.get_url(this.$editor.data('image-upload-url'));
			}

			opts.media_live_embeds = true;

			// init
			tinymce.init(opts).then(function ready(editors) {
				self.$editor.trigger('editor.ready', editors[0]);

				editors[0].on('dblclick', function _captureClick(e) {
					if (e.target.className === 'video-library-placeholder img-responsive') {
						showVideoModal($(e.target).data('video-url'));
					}
				});
			});

			this.$editor.addClass('has-html');
		}
		catch (err)
		{
			console.log('[Adzuki.Editor]', err);
		}

		// cp images toolbar item functions
		function showImagePicker(editor)
		{
			$modal.addClass('wide');
			$modal.find('.modal-title').text('Image Library');
			$modal.find('.modal-body').text('Loading image library...');

			Adzuki.Ajax.get('/Images/imagePicker')
			.then(function _showImagePicker(html) {
				$modal.find('.modal-body').html(html);

				Adzuki.Form.initAjaxForm('ImageSearch');
			});

			// delegate the events to the modal node, because this module
			// can be called from anywhere, .modal is always present,
			// and it's the closest node to the selector when the event bubbles up.
			// delegation is done on-demand here in order to pass a reference
			// of the current editor object, so we know which editor to place
			// the selected image in.
			$modal.on('click', '.image-picker .select-image', function selectImage() {
				var $image = $(this).parents('.image-container').find('img');

				// adds the image to the recent image list
				setRecent($image.data("id"));

				if (image_size !== undefined) { // eslint-disable-line no-negated-condition
					switch (image_size) {
						case 'small': // 100px
							editor.insertContent('<img class="img-responsive" src="'+$image.attr('src')+'" style="max-width: 100px">');
						break;
						case 'medium': // 250px
							editor.insertContent('<img class="img-responsive" src="'+$image.attr('src')+'" style="max-width: 250px">');
						break;
						case 'large': // 500px
							editor.insertContent('<img class="img-responsive" src="'+$image.attr('src')+'" style="max-width: 500px">');
						break;
						case 'xl': // 1000px
							editor.insertContent('<img class="img-responsive" src="'+$image.attr('src')+'" style="max-width: 1000px">');
						break;
						case 'original':
						default:
							editor.insertContent('<img class="img-responsive" src="'+$image.attr('src')+'">');
						break;
					}
				} else {
					editor.insertContent('<img class="img-responsive" src="'+$image.attr('src')+'">');
				}

				$modal.modal('hide');
			});

			$modal.on('click', '.image-picker-container .add-button-btn', function addImageButtonPressed() {
				Adzuki.CustomConfirm({
					title  : 'Add image?',
					content: 'Adding images must be done through the Image section of the web program. Clicking \'Ok\' will take you there now. Would you like to go? Please note any unsaved work may be lost.',
					confirm: function confirm() {
						document.location = Adzuki.base_uri + '/Images/add/';
					}
				});
			});

			$modal.on('click', '.image-size-setting', function setImageSize(e) {
				e.preventDefault();

				image_size = $(this).data("value");

				$(".image-size .btn-group .btn:first-child").text($(this).text());
				$(".image-size .btn-group .btn:first-child").val($(this).text());
			});

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal')
				      .off('click', '.image-picker .select-image')
				      .off('click', '.image-picker-container .add-button-btn');
			}).modal('show');
		}

		function setRecent(image_id) {
			Adzuki.Ajax.get('/Images/setRecent/' + image_id);
		}

		// lead forms toolbar item functions
		function showFormSelector(editor)
		{
			$modal.find('.modal-title').text('Forms');
			$modal.find('.modal-body').text('Loading forms...');

			Adzuki.Ajax.get('/ClientLeadForms/forms')
			.then(function _showClientLeadForms(html) {
				$modal.find('.modal-body').html(html);
			});

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');

			$modal.on('click', '.lead-form', function selectForm() {
				var form_id       = $(this).data('id'),
					form_name     = $(this).data('name'),
					existing_page = editor.getContent({format: 'raw'});

				if (existing_page.indexOf('lead-form-container') > 0) {
					Adzuki.StatusMessage('Error', 'You can only have one CP Maxx form per page.');
				} else {
					editor.insertContent('<div class="lead-form-container" id="form-id-'+ form_id + '"><table cellpadding="10" cellspacing="0" style="padding: 10px; background-color: #FFFFF; text-align:center; font-size: 16px; border: 2px solid #666; color: #00000"><tr><td style="padding: 10px;"><img src="' + Adzuki.base_uri + '/images/maxx.png"></td><td style="padding: 10px;"><b>CP MAXX FORM</b><br> ' + form_name + '</td></tr></table></div><p></p>');
				}

				$modal.modal('hide');
				$modal.off('click', '.lead-form');
			});
		}

		function removeForm(editor)
		{
			var old_content = editor.getContent({format: 'raw'}),
				new_content = '',
				pattern     = /<div\s+id="form-id-[^"]*" class="lead-form-container">[\S\s]*?<\/div>/gi;

			if (old_content.match(pattern)) {
				new_content = old_content.replace(pattern, '');
				editor.setContent(new_content);
				editor.insertContent('');
			}
		}

		// snippets toolbar item functions
		function showSnippets(editor)
		{
			$modal.find('.modal-title').text('My Snippets');
			$modal.find('.modal-body').text('Loading Snippets...');
			$modal.find('.modal-body').html('');

			Adzuki.Ajax.get('/Snippets/snippetsPrompt')
			.then(function _showSnippets(html) {
				$modal.find('.modal-body').html(html);
				Adzuki.Form.initAjaxForm('SnippetPrompt');
			});

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');

			// remove previous event listeners
			$modal.off('click', '.insert-snippet');

			$modal.on('click', '.insert-snippet', function _insertContent(e) {
				var content = '';

				e.preventDefault();

				content = $(this).data('snippet');

				if (content.length === 0) {
					Adzuki.StatusMessage('Error', 'There must be a snippet selected in order to proceed.');
					return false;
				}

				editor.insertContent(content + ' ');

				$modal.modal('hide');
			});
		}

		// maxx intelligence toolbar item functions
		function showGptPrompt(editor)
		{
			var content = '';

			$modal.find('.modal-title').text('Maxx Intelligence');
			$modal.find('.modal-body').text('Loading Maxx Intelligence...');
			$modal.find('.modal-body').html('');

			// remove previous event listeners
			$modal.off('click', '.insert-from-history');
			$modal.off('click', '.gpt-insert-content');

			Adzuki.Ajax.get('/Ai/gptPrompt')
			.then(function _showGptPrompt(html) {
				$modal.find('.modal-body').html(html);

				Adzuki.Form.initAjaxForm('GptPrompt');

				// load history tab
				Adzuki.Ajax.get('/Ai/gptHistory')
				.then(function viewHistory(response) {
					$modal.find('#gpt-history').html(response);
				});
			});

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');

			$('#gptprompt-gpt_response').val('');

			// logic for inserting content from history
			$modal.on('click', '.insert-from-history', function _insertContent(e) {
				var prompt   = $(this).data('prompt'),
					response = $(this).data('response');

				e.preventDefault();

				$('#gptprompt-gpt_prompt').val(prompt);
				$('#gptprompt-gpt_response').val(response);

				$('.gpt-insert-content').trigger('click');
			});

			// logic for handling prompt content insertion
			$modal.on('click', '.gpt-insert-content', function insertGptResponse(e) {
				content = $('#gptprompt-gpt_response').val();

				e.preventDefault();

				if (content.length === 0) {
					Adzuki.StatusMessage('Error', 'There must be a response provided in order to proceed.');
					return false;
				}

				content = content.replace(/\\r\\n/g, "<br />");
				content = content.replace(/\n/g, "<br />");

				editor.insertContent(content);

				$modal.modal('hide');
			});
		}

		function showVideoLibrary(editor)
		{
			var content = '';

			$modal.find('.modal-title').text('Video Library');
			$modal.find('.modal-body').text('Loading Video Library...');

			$modal.off('click', '.insert-video');

			Adzuki.Ajax.get('/Videos/library')
			.then(function _showVideoLibrary(html) {
				$modal.find('.modal-body').html(html);
				Adzuki.Form.initAjaxForm('VideoFilter');
			});

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');


			$modal.on('click', '.insert-video', function insertVideoContent(e) {
				var video_url   = $(this).data('video-url'),
					thumbnail   = $(this).data('thumbnail'),
					internal_id = Math.floor(Date.now() / 1000),
					video_id    = $(this).data('id'),
					data_key    = $(this).data('key'),
					video_size  = $('.insert-video-size[data-key="' + data_key + '"]').val(),
					website     = $(this).data('website');

				e.preventDefault();

				content = '<img src="' + Adzuki.base_uri + '/' + thumbnail + '" class="video-library-placeholder img-responsive" style="max-width: ' + video_size + '" data-video-url="' + video_url + '" data-video-thumbnail="' + Adzuki.base_uri + '/' + thumbnail + '" data-internal-id="' + internal_id + '" data-video-website="' + website + '" data-video-id="' + video_id + '" />';
				content += '<br>';

				editor.insertContent(content);
				$modal.modal('hide');
			});
		}

		function showVideoModal(video_url)
		{
			$modal.find('.modal-title').text('Video');
			$modal.find('.modal-body').text('Loading Video...');

			Adzuki.Ajax.get('/Videos/viewVideoByUrl/' + encodeURIComponent(video_url))
			.then(function _showVideoModal(html) {
				$modal.find('.modal-body').html(html);
			});

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		}
	};

	Adzuki.Editor = editor;
}(jQuery, window.Adzuki || {}, window.tinymce || {}));
